import React from "react"
import { NotLogguedRoutes } from "ui/components/router/NotLogguedRoutes"

export const NotLogguedPage = () => <NotLogguedRoutes />
